import React from 'react';

import { useTranslation } from 'react-i18next';

import { Step } from '@features/AdminConversationCategoryUpsertModal/model/types';
import { CustomModal, UiButton } from '@shared/ui';

import cls from './SelectStep.module.css';

interface SelectStepProps {
    onChangeStep: (value: Step) => void;
}

export const SelectStep = ({ onChangeStep }: SelectStepProps) => {
    const { t } = useTranslation();
    return (
        <>
            <CustomModal.Header classes={cls.header}>
                {t('SelectStep.return.CustomModal.Header')}
            </CustomModal.Header>
            <CustomModal.Footer classes={cls.footer}>
                <UiButton
                    onClick={() => onChangeStep(Step.SURVEY)}
                    btnText={t('SelectStep.return.CustomModal.Footer.UiButton.survey.btnText')}
                />
                <UiButton
                    onClick={() => onChangeStep(Step.NEWSLETTER)}
                    btnText={t('SelectStep.return.CustomModal.Footer.UiButton.mailing.btnText')}
                />
            </CustomModal.Footer>
        </>
    );
};
